import { render, staticRenderFns } from "./horizontal.vue?vue&type=template&id=f560364e&scoped=true"
import script from "./horizontal.vue?vue&type=script&lang=ts"
export * from "./horizontal.vue?vue&type=script&lang=ts"
import style0 from "./horizontal.vue?vue&type=style&index=0&id=f560364e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f560364e",
  null
  
)

export default component.exports